import { TaskAPIError } from '../types/public-types';
import { ITaskService } from '../types/internal-types';
import {
    AITaskRequest,
    AITaskResponse,
    AITaskListResponse
} from '../types/server-types';
import { AITaskAdapter } from './ai-task.adapter';

export class AITaskService extends AITaskAdapter implements ITaskService {
    async executeTask(request: AITaskRequest): Promise<AITaskResponse> {
        try {
            const newAITask = await this._executeTask(request);

            // Validate required response fields
            if (!newAITask.ai_task_id || !newAITask.feature) {
                throw new TaskAPIError(
                    'Invalid task response from server - missing required fields'
                );
            }

            return newAITask;
        } catch (error) {
            if (error instanceof TaskAPIError) {
                throw error;
            }

            throw new TaskAPIError('Failed to execute task', error);
        }
    }

    async fetchTasks(taskIds?: string[]): Promise<AITaskListResponse> {
        try {
            const response = await this._fetchTasks(taskIds);

            // Validate response structure
            if (!Array.isArray(response.tasks)) {
                throw new TaskAPIError('Invalid tasks response from server');
            }

            // Validate each task has required fields
            for (const task of response.tasks) {
                if (!task.ai_task_id || !task.feature) {
                    throw new TaskAPIError(
                        'Invalid task data in response - missing required fields'
                    );
                }
            }

            return response;
        } catch (error) {
            if (error instanceof TaskAPIError) {
                throw error;
            }
            throw new TaskAPIError('Failed to fetch tasks', error);
        }
    }

    getTask(taskId: string): Promise<AITaskResponse> {
        return this._getTask(taskId);
    }
}
